import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Directory } from './directory';
var queryClient = new QueryClient();
var Index = function () {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(Directory, null)));
};
export { Index };
